import { REQUEST_PARTNER_DISCOUNTS, RECEIVE_PARTNER_DISCOUNTS, FAILURE_PARTNER_DISCOUNTS } from './constants';
import { combineReducers } from 'redux';

/*
 * State shape
 {
    discounts: {
        [idPartnerA]: [{},{},{}],
        [idPartnerB]: [{},{},{}],
        [...], [{},{},{},...]
    },
    fetching: false,
    error: ''
 }
 */

const discounts = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_PARTNER_DISCOUNTS:
            return { ...state, [action.id]: action.response.payload };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PARTNER_DISCOUNTS:
            return true;
        case FAILURE_PARTNER_DISCOUNTS:
        case RECEIVE_PARTNER_DISCOUNTS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PARTNER_DISCOUNTS:
            return action.response.message;
        case REQUEST_PARTNER_DISCOUNTS:
        case RECEIVE_PARTNER_DISCOUNTS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    discounts,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/discount/reducer.js